<br />
<div class="float-right">
  <img
    src="assets/images/icons/default_icons/icon-close.png"
    id="closebtn"
    alt="icon-close"
    (click)="OnClose()"
    style="cursor: pointer; float: right; margin-right: 10px"
  />
</div>
<mat-dialog-content>
  <div *ngIf="genmodel" [hidden]="showAttach">
    <div>
      <span class="candProfile"> Candidate Profile</span>
      <button
        class="btn btn-sm genButton float-right"
        [ngStyle]="{ outline: '0' }"
        *ngIf="roleCheck"
        (click)="regenerate()"
      >
        <span class="editText">Regenerate HR Form</span>
      </button>
    </div>
    <hr class="horizontalLine" />
    <span *ngIf="!inOffer" class="float-right">
      <button class="btn btn-sm viewProfleBtn" *ngIf="!isEdit" (click)="iseditable()" [disabled]="profileEdit">
        <span class="editText">Edit</span>
      </button>
      <button
        name="dbAdmindownload"
        *ngIf="checkApp"
        class="btn btn-sm marL10 viewProfleBtn"
        (click)="downloadApplication(data.applicationId)"
      >
        <img class="padL6 editText" src="assets/images/webIcons/default_icons/download (1).png" alt="download (1)" />
      </button>
    </span>

    <div class="float-right">
      <button *ngIf="isEdit" class="btn btn-sm viewProfleBtn" (click)="saveBasicDetails()">Save</button>
    </div>
    <br />
    <ng-container *ngIf="genmodel?.fields">
      <app-dynamic-candidate-profile
        [genModel]="genmodel?.fields"
        [isEdit]="isEdit"
        [infyProfileEdit]="infyProfileEdit"
        #candidate
      >
      </app-dynamic-candidate-profile>
    </ng-container>

    <br />
    <br />

    <br />

    <mat-accordion class="accordion">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong> Address</strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.address">
          <div class="float-right">
            <button
              *ngIf="isEdit && genmodel?.address.length < 2"
              class="btn btn-sm viewProfleBtn"
              (click)="addAddress()"
              [disabled]="infyProfileEdit"
            >
              Add
            </button>
            <span class="padR4"></span>
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn"
              (click)="saveAddress()"
              [disabled]="infyProfileEdit"
            >
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let adrs of genmodel?.address; let i = index">
            <div class="degreeName">
              Address<span *ngIf="isEdit" class="padL4" [ngClass]="{ 'disabled-span': infyProfileEdit }">
                <img
                  src="assets/images/icons/default_icons/icon-close.png"
                  id="closeIconAdr"
                  style="cursor: pointer"
                  alt="iconClose"
                  (click)="removeAddress(i, adrs)"
                />
              </span>
            </div>
            <app-dynamic-candidate-profile
              [genModel]="adrs.fields"
              [candidateId]="data.candidateId"
              [isEdit]="isEdit"
              #address
              [infyProfileEdit]="infyProfileEdit"
            >
            </app-dynamic-candidate-profile>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="accordion">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong> Education Details</strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.educations">
          <div class="float-right">
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn"
              (click)="addEducation()"
              [disabled]="infyProfileEdit"
            >
              Add
            </button>
            <span class="padR4"></span>
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn"
              [disabled]="saveEduDisable || infyProfileEdit"
              (click)="saveEducation()"
            >
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let education of genmodel?.educations; let i = index">
            <div class="degreeName">
              {{ education.degreeName
              }}<span *ngIf="isEdit" class="padL4" id="target-{{ i }}"
                ><img
                  src="assets/images/icons/default_icons/icon-close.png"
                  id="closeIconEducation"
                  style="cursor: pointer"
                  alt="iconClose"
                  [ngClass]="{ 'disabled-span': infyProfileEdit }"
                  (click)="removeEducation(i, education)"
              /></span>
            </div>
            <app-dynamic-candidate-profile
              [genModel]="education.fields"
              [isEdit]="isEdit"
              #edu
              [infyProfileEdit]="infyProfileEdit"
            >
            </app-dynamic-candidate-profile>
            <div
              class="text-center"
              class="col-md-5"
              *ngIf="
                isEdit &&
                (companyHiringType == 4 || companyHiringType == 5 || companyHiringType == 9) &&
                checkEdu(education, i)
              "
            >
              <button mat-flat-button name="addAttach" class="Icon-Btn" (click)="hideMainPage(education, 'edu', i)">
                <img id="addAttachicon" alt="icon-add" src="assets/images/icons/purple_icons/icon-add-dark.png" />
                <span name="addAttachText">Attach supporting document</span>
              </button>
            </div>
            <hr *ngIf="i < genmodel?.educations.length - 1" />
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="accordion">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong> Work Experience Details For Current Employment</strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.experience">
          <div class="float-right">
            <button
              *ngIf="isEdit && (!genmodel?.isHRCheckList || roleCheck)"
              class="btn btn-sm viewProfleBtn padR4"
              (click)="addExperience()"
              [disabled]="infyProfileEdit"
            >
              Add
            </button>
            <span class="padR4"></span>
            <button
              *ngIf="isEdit && (!genmodel?.isHRCheckList || roleCheck)"
              class="btn btn-sm viewProfleBtn"
              [disabled]="saveExpDisable || infyProfileEdit"
              (click)="saveExperience()"
            >
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let exp of genmodel?.experience; let i = index">
            <div class="degreeName">
              Experience<span
                *ngIf="isEdit && (!genmodel?.isHRCheckList || roleCheck)"
                class="padL4"
                [ngClass]="{ 'disabled-span': infyProfileEdit }"
                id="targetExp-{{ i }}"
                ><img
                  src="assets/images/icons/default_icons/icon-close.png"
                  id="closeIconexp"
                  style="cursor: pointer"
                  alt="iconClose"
                  (click)="removeExperience(i, exp)"
              /></span>
            </div>
            <app-dynamic-candidate-profile
              [genModel]="exp.fields"
              [candidateId]="data.candidateId"
              [infyProfileEdit]="infyProfileEdit"
              [isEdit]="isEdit && (!genmodel?.isHRCheckList || roleCheck)"
              #experience
            >
            </app-dynamic-candidate-profile>
            <div
              class="text-center"
              class="col-md-5"
              *ngIf="
                isEdit && (companyHiringType == 4 || companyHiringType == 5 || companyHiringType == 9) && checkExp(exp)
              "
            >
              <button mat-flat-button name="addAttach" class="Icon-Btn" (click)="hideMainPage(exp, 'exp', i)">
                <img id="addAttachicon" alt="icon-add" src="assets/images/icons/purple_icons/icon-add-dark.png" />
                <span name="addAttachText">Attach supporting document</span>
              </button>
            </div>
            <hr *ngIf="i < genmodel?.experience.length - 1" />
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="accordion" *ngIf="genmodel?.showGaps">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong>Gaps</strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.gaps">
          <div class="float-right">
            <button
              *ngIf="isEdit"
              style="width: 150px !important"
              class="btn btn-sm viewProfleBtn padR4"
              (click)="addEduGaps()"
              [disabled]="infyProfileEdit"
            >
              Add Education Gaps
            </button>
            <span class="padR4"></span>
            <button
              *ngIf="isEdit"
              style="width: 150px !important"
              class="btn btn-sm viewProfleBtn"
              (click)="addExpGaps()"
              [disabled]="infyProfileEdit"
            >
              Add Experience Gaps
            </button>
            <span class="padR4"></span>
            <button *ngIf="isEdit" class="btn btn-sm viewProfleBtn" (click)="saveGaps()" [disabled]="infyProfileEdit">
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let gap of genmodel?.gaps; let i = index">
            <div class="degreeName">
              {{ gap.gapType
              }}<span *ngIf="isEdit" class="padL4" [ngClass]="{ 'disabled-span': infyProfileEdit }"
                ><img
                  src="assets/images/icons/default_icons/icon-close.png"
                  id="closeIconexp"
                  style="cursor: pointer"
                  alt="iconClose"
                  (click)="removeGaps(i, gap)"
              /></span>
            </div>
            <app-dynamic-candidate-profile
              [genModel]="gap.fields"
              [isEdit]="isEdit"
              #gaps
              [infyProfileEdit]="infyProfileEdit"
            >
            </app-dynamic-candidate-profile>
            <hr *ngIf="i < genmodel?.gaps.length - 1" />
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="accordion" *ngIf="genmodel?.showCNB">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong> Compensation</strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.compensation">
          <div class="float-right">
            <button
              *ngIf="isEdit && genmodel?.compensation.length < 3"
              class="btn btn-sm viewProfleBtn padR4"
              (click)="addCompensation()"
              [disabled]="infyProfileEdit"
            >
              Add
            </button>
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn"
              [disabled]="infyProfileEdit"
              (click)="saveCompensation()"
            >
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let comp of genmodel?.compensation; let i = index">
            <div class="degreeName">{{ comp.label }}</div>
            <app-dynamic-candidate-profile
              [genModel]="comp.fields"
              [candidateId]="data.candidateId"
              [isEdit]="isEdit"
              [infyProfileEdit]="infyProfileEdit"
              #comps
            >
            </app-dynamic-candidate-profile>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="accordion" *ngIf="genmodel?.showAttachments">
      <mat-expansion-panel [expanded]="true" [ngClass]="{ editexpansionPanel: isEdit, noeditexpansionPanel: !isEdit }">
        <mat-expansion-panel-header class="customExpansionPanel">
          <strong> Attachments Upload </strong>
        </mat-expansion-panel-header>
        <br />
        <ng-container *ngIf="genmodel?.attachments">
          <div class="float-right">
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn padR4"
              (click)="addAttachment()"
              [disabled]="infyProfileEdit"
            >
              Add
            </button>
            <span class="padR4"></span>
            <button
              *ngIf="isEdit"
              class="btn btn-sm viewProfleBtn"
              [disabled]="saveAttachDisable"
              (click)="saveAttachment('save')"
              [disabled]="infyProfileEdit"
            >
              Save
            </button>
          </div>
          <br />
          <div *ngFor="let atch of genmodel?.attachments; let i = index">
            <div class="degreeName">
              Attachment<span *ngIf="isEdit" class="padL4" [ngClass]="{ 'disabled-span': infyProfileEdit }"
                ><img
                  src="assets/images/icons/default_icons/icon-close.png"
                  id="closeIconexp"
                  style="cursor: pointer"
                  alt="iconClose"
                  (click)="removeAttachment(i, atch)"
              /></span>
            </div>
            <app-dynamic-candidate-profile
              [candidateDetails]="data"
              [genModel]="atch.fields"
              [candidateId]="data.candidateId"
              [isEdit]="isEdit"
              #attach
              [saved]="saved"
              [infyProfileEdit]="infyProfileEdit"
              [saveDocId]="saveDocId"
            >
            </app-dynamic-candidate-profile>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="marB4">
      <button
        type="submit"
        name="submitProfile"
        mat-flat-button
        class="primary-btn"
        *ngIf="isEdit"
        [disabled]="infyProfileEdit"
        (click)="submit()"
      >
        Submit
      </button>
      <button
        type="button"
        name="cancelButton"
        mat-flat-button
        class="primary-btn marL16"
        *ngIf="isEdit"
        [disabled]="infyProfileEdit"
        (click)="iseditable()"
      >
        Cancel
      </button>
      <span *ngIf="!isEdit && selectedActivity()"
        ><button
          type="update"
          name="updateProfile"
          mat-flat-button
          class="float-right primary-btn"
          [disabled]="lpdisable"
          (click)="lpPushbutton()"
        >
          LP Data Push
        </button></span
      >
    </div>

    <br />
  </div>

  <div class="tab-wrap" [hidden]="!showAttach">
    <div>
      <h3 class="h3 pad8 text-left">Document details</h3>
      <p class="pad8 fileDesc">Only originally scanned .JPG/.JPEG/.PDF files with 5MB can be uploaded.</p>
    </div>
    <div>
      <ng-container [ngSwitch]="dispAttach">
        <ng-template [ngSwitchCase]="['X', 'XII'] | switchMultiCase: dispAttach">
          <div class="padTB16" *ngFor="let item of XPostGradList; let i = index">
            <div class="col-10 col-md-10 d-inline-block">
              <span
                *ngIf="checkFileInserted(dispAttach, i)"
                (click)="downloadOrDeleteAttachment(dispAttach, i, 'Download')"
                class="marR8"
                ><img
                  alt="calm"
                  width="32"
                  height="32"
                  src="assets/images/icons/default_icons/icon-attachment.png"
                  style="cursor: pointer"
                />
              </span>
              <label for="id_d1" class="label-constant1">{{ item }}</label>
            </div>
            <div class="col-2 d-inline-block">
              <ul class="list-none">
                <li>
                  <a
                    *ngIf="!checkFileInserted(dispAttach, i)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="customClick(i)"
                    (change)="fileChange(file.files[0], dispAttach, item, i)"
                    data-max-size="5120"
                  >
                    <input id="{{ 'fileInput-' + i }}" type="file" style="display: none" #file type="file" /><img
                      alt="calc"
                      src="assets/images/icons/purple_icons/icon-upload.png"
                  /></a>
                  <a
                    *ngIf="checkFileInserted(dispAttach, i)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="downloadOrDeleteAttachment(dispAttach, i, 'Delete')"
                  >
                    <img width="32" alt="calz" height="32" src="assets/images/icons/purple_icons/icon-delete-mini.png"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="padTB24">
            <button class="btn btn-sm viewProfleBtn" (click)="showEducation()">Back</button>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="['grad', 'postGrad', 'diploma'] | switchMultiCase: dispAttach">
          <div class="form-group" style="margin-bottom: 4%">
            <label for="sheetType" class="fileDesc padTB16 padL8"
              >Please select an option to upload Documents.&nbsp;<span class="text-danger">*</span></label
            >

            <div class="row">
              <div class="custom-check-box1 col-4">
                <input
                  class="styled-checkbox"
                  id="saving"
                  #sheetType
                  type="radio"
                  value="S"
                  name="sheetType"
                  checked
                  (click)="selectedType('S')"
                />
                <label for="saving" class="text-dark padL8">Semester wise Marksheets</label>
              </div>

              <div class="custom-check-box1 col-6">
                <input
                  class="styled-checkbox"
                  id="checking"
                  #sheetType
                  type="radio"
                  value="C"
                  name="sheetType"
                  (click)="selectedType('C')"
                />
                <label for="checking" class="text-dark padL8">Consolidated Marksheet</label>
              </div>
            </div>
          </div>
          <div *ngIf="uploadType === 'S'">
            <div class="b-cardsn" *ngFor="let item of semesterList; let i = index">
              <div class="col-10 col-md-10 d-inline-block" style="padding-top: 5px">
                <span
                  *ngIf="checkFileInserted(dispAttach, i)"
                  (click)="downloadOrDeleteAttachment(dispAttach, i, 'Download')"
                  class="marR8"
                  ><img
                    alt="calb"
                    width="32"
                    height="32"
                    src="assets/images/icons/default_icons/icon-attachment.png"
                    style="cursor: pointer"
                  />
                </span>
                <label for="id_d1" class="label-constant1">{{ item }}</label>
              </div>
              <div class="col-2 d-inline-block">
                <ul class="list-none">
                  <li>
                    <a
                      *ngIf="!checkFileInserted(dispAttach, i)"
                      href="javascript:void(0);"
                      class="icon_Add"
                      (click)="customClick(i)"
                      (change)="fileChange(file.files[0], dispAttach, null, i)"
                    >
                      <input id="{{ 'fileInput-' + i }}" type="file" style="display: none" #file type="file" /><img
                        alt="calp"
                        src="assets/images/icons/purple_icons/icon-upload.png"
                    /></a>
                    <a
                      *ngIf="checkFileInserted(dispAttach, i)"
                      href="javascript:void(0);"
                      class="icon_Add"
                      (click)="downloadOrDeleteAttachment(dispAttach, i, 'Delete')"
                    >
                      <img
                        alt="calx"
                        width="32"
                        height="32"
                        src="assets/images/icons/purple_icons/icon-delete-mini.png"
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="uploadType === 'C'">
            <div class="b-cardsn" *ngFor="let item of marksWiseList; let i = index">
              <div class="col-10 col-md-10 d-inline-block" style="padding-top: 5px">
                <span
                  *ngIf="checkFileInserted(dispAttach, i)"
                  (click)="downloadOrDeleteAttachment(dispAttach, i, 'Download')"
                  class="marR8"
                  ><img
                    alt="calw"
                    width="32"
                    height="32"
                    src="assets/images/icons/default_icons/icon-attachment.png"
                    style="cursor: pointer"
                  />
                </span>
                <label for="id_d1" class="label-constant1">{{ item }}</label>
              </div>
              <div class="col-2 d-inline-block">
                <ul class="list-none">
                  <li>
                    <a
                      *ngIf="!checkFileInserted(dispAttach, i)"
                      href="javascript:void(0);"
                      class="icon_Add"
                      (click)="customClick(i)"
                      (change)="fileChange(file.files[0], dispAttach, null, i)"
                    >
                      <input id="{{ 'fileInput-' + i }}" type="file" style="display: none" #file type="file" /><img
                        alt="calq"
                        src="assets/images/icons/default_icons/icon-upload.png"
                    /></a>
                    <a
                      *ngIf="checkFileInserted(dispAttach, i)"
                      href="javascript:void(0);"
                      class="icon_Add"
                      (click)="downloadOrDeleteAttachment(dispAttach, i, 'Delete')"
                    >
                      <img
                        width="32"
                        height="32"
                        alt="cals"
                        src="assets/images/icons/purple_icons/icon-delete-mini.png"
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="text-left margin-top30 col-12 col-sm-6 offset-sm-3 col-md-4 offset-md-0 padTB24">
            <button class="btn btn-sm viewProfleBtn" name="AptsaveText" (click)="showEducation()">Back</button>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="['noCurrentEmp'] | switchMultiCase: dispAttach">
          <div class="padTB16" *ngFor="let item of noCurrentEmp; let i = index">
            <div class="col-10 col-md-10 d-inline-block">
              <span
                *ngIf="checkFileInserted(dispAttach, i)"
                (click)="downloadOrDeleteExpAttachment(dispAttach, i, 'Download')"
                class="marR8"
                ><img
                  alt="calm"
                  width="32"
                  height="32"
                  src="assets/images/icons/default_icons/icon-attachment.png"
                  style="cursor: pointer"
                />
              </span>
              <label for="id_d1" class="label-constant1">{{ item }}</label>
            </div>
            <div class="col-2 d-inline-block">
              <ul class="list-none">
                <li>
                  <a
                    *ngIf="!checkFileInserted(dispAttach, i)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="customClick(i)"
                    (change)="fileChange(file.files[0], dispAttach, item, i)"
                    data-max-size="5120"
                  >
                    <input id="{{ 'fileInput-' + i }}" type="file" style="display: none" #file type="file" /><img
                      alt="calc"
                      src="assets/images/icons/purple_icons/icon-upload.png"
                  /></a>
                  <a
                    *ngIf="checkFileInserted(dispAttach, i)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="downloadOrDeleteExpAttachment(dispAttach, i, 'Delete')"
                  >
                    <img width="32" alt="calz" height="32" src="assets/images/icons/purple_icons/icon-delete-mini.png"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="padTB24">
            <button class="btn btn-sm viewProfleBtn" (click)="showEducation()">Back</button>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="['currentEmp'] | switchMultiCase: dispAttach">
          <div class="padTB16" *ngFor="let elem of currentEmp; let j = index">
            <div class="col-10 col-md-10 d-inline-block">
              <span
                *ngIf="checkFileInserted(dispAttach, j)"
                (click)="downloadOrDeleteExpAttachment(dispAttach, j, 'Download')"
                class="marR8"
                ><img
                  alt="calm"
                  width="32"
                  height="32"
                  src="assets/images/icons/default_icons/icon-attachment.png"
                  style="cursor: pointer"
                />
              </span>
              <label for="id_d1" class="label-constant1">{{ elem }}</label>
            </div>
            <div class="col-2 d-inline-block">
              <ul class="list-none">
                <li>
                  <a
                    *ngIf="!checkFileInserted(dispAttach, j)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="customClick(j)"
                    (change)="fileChange(file.files[0], dispAttach, elem, j)"
                    data-max-size="5120"
                  >
                    <input id="{{ 'fileInput-' + j }}" type="file" style="display: none" #file type="file" /><img
                      alt="calc"
                      src="assets/images/icons/purple_icons/icon-upload.png"
                  /></a>
                  <a
                    *ngIf="checkFileInserted(dispAttach, j)"
                    href="javascript:void(0);"
                    class="icon_Add"
                    (click)="downloadOrDeleteExpAttachment(dispAttach, j, 'Delete')"
                  >
                    <img width="32" alt="calz" height="32" src="assets/images/icons/purple_icons/icon-delete-mini.png"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="padTB24">
            <button class="btn btn-sm viewProfleBtn" (click)="showEducation()">Back</button>
          </div>
        </ng-template>

        <ng-template *ngSwitchDefault> </ng-template>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>
